import { useMutation } from '@tanstack/react-query';
import type { SubmitFeedbackRequest } from '@vagusx/clients';
import { getFeedbackClient } from '@/lib/api-clients';

/**
 * Hook for the in-app feedback widget. Fire-and-forget — there is no
 * server-side persistence, just an email to the recipients configured
 * via FEEDBACK_RECIPIENTS on the API.
 */
export function useSubmitFeedback() {
  return useMutation({
    mutationFn: ({
      payload,
      attachments,
    }: {
      payload: SubmitFeedbackRequest;
      attachments?: File[];
    }) => getFeedbackClient().submit(payload, attachments),
  });
}
